import Page from '../../enums/Page';
import {orderStatusPromisePoller} from '../api/pollers/pollers';
import {redirect} from '../api/redirect';
import PaymentHelper from '../order-processing/payment-helper';
import getPage from '../page/getPage';
import isOrderSfExpress from '../selectors/DeliveryOptionsSelectors/isOrderSfExpress';
import {getSelectedPaymentOption} from '../selectors/selectors';
import DomUtils from '../utils/DomUtils';
import Track from '../utils/tracking';
import {
  SET_APPLEPAY_SESSION_STARTED,
  SET_ORDER_IS_PROCESSING,
  SET_RETURN_HOST_PAYMENT,
  SET_SITE_VALUES,
  SET_WECHAT_PROCESSED,
} from './action-types';
import {hideOverlay, showOverlay} from './overlay-actions';

export const setSiteValues = values => (
  {type: SET_SITE_VALUES, values}
);

export const setReturnFromHostPayment = () => ({
  type: SET_RETURN_HOST_PAYMENT,
});

export const setOrderIsProcessing = isProcessing => ({
  type: SET_ORDER_IS_PROCESSING,
  isProcessing,
});

export const setApplePaySessionStarted = isStarted => ({
  type: SET_APPLEPAY_SESSION_STARTED,
  isStarted,
});

export const setWechatProcessed = isProcessed => ({
  type: SET_WECHAT_PROCESSED,
  isProcessed,
});

export const startOrderProcessing = (shouldShowOverlay = true) => (dispatch, getState) => {
  dispatch(setOrderIsProcessing(true));
  if (shouldShowOverlay) {
    dispatch(showOverlay('order_processing', {isSfExpress: isOrderSfExpress(getState())}));
  }
};

export const stopOrderProcessing = (scrollToTop = true) => (dispatch, getState) => {
  dispatch(hideOverlay());
  dispatch(setOrderIsProcessing(false));
  if (scrollToTop) {
    DomUtils.scrollToTop();
  }
  
  const selectedPaymentOption = getSelectedPaymentOption(getState());
  if (selectedPaymentOption?.isAdyenV2Option && selectedPaymentOption.component) {
    selectedPaymentOption.component.setStatus('ready');
  }
};

export const threeDSecureSuccess = () => () => {
  if (getPage() === Page.PROCESSING) {
    orderStatusPromisePoller.runPoller()
      .then(response => PaymentHelper.processResponse(response))
      .then(redirectUrl => redirectUrl)
      .catch((error) => {
        Track.error(`Error processing order, redirecting for 3DS. ${error}`);
        redirect.doRedirect('/checkout?error=true');
        return 'ERROR';
      })
      .then((url) => {
        if (url !== 'QR_CODE' && url !== '3DS_REQUIRED' && url !== 'ERROR') {
          redirect.doRedirect('/checkout/complete?app=express');
        }
      });
  } else {
    redirect.doRedirect('/checkout/processing');
  }
};
